export enum MCTransactionTypes {
  BoxOffice,
  DstvTopUp,
  DstvPayment,
  GotvPayment,
  ShowmaxPayment,
  DVSPayment,
}

export enum PaymentAttribution {
  BuyPrinciblePackage = 'dswebbp',
  BuyContractPackage = 'dswebbpspl',
  PayAccount = 'dswebpa',
  Payreconnect = 'dswebpr',
  SetCreditCard = 'dswebsc',
}
